export const getPreTimeoutList = (state) => state.timeout.preTimeoutList;

export const getIsInit = (state) => state.timeout.isInit;